import LangBtn from './LangBtn.vue';

export default LangBtn;
